/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalAuthSubmissionMetadataErrorDetailsPayerNotFound } from './PalAuthSubmissionMetadataErrorDetailsPayerNotFound';
import {
    PalAuthSubmissionMetadataErrorDetailsPayerNotFoundFromJSON,
    PalAuthSubmissionMetadataErrorDetailsPayerNotFoundFromJSONTyped,
    PalAuthSubmissionMetadataErrorDetailsPayerNotFoundToJSON,
    PalAuthSubmissionMetadataErrorDetailsPayerNotFoundToJSONTyped,
} from './PalAuthSubmissionMetadataErrorDetailsPayerNotFound';

/**
 * 
 * @export
 * @interface PalAuthSubmissionMetadataErrorDetails
 */
export interface PalAuthSubmissionMetadataErrorDetails {
    /**
     * 
     */
    diagnosis_not_found?: string;
    /**
     * 
     */
    invalid_servicing_provider_name?: string;
    /**
     * 
     */
    platform_message?: string;
    /**
     * 
     */
    payer_not_found?: PalAuthSubmissionMetadataErrorDetailsPayerNotFound;
}

/**
 * Check if a given object implements the PalAuthSubmissionMetadataErrorDetails interface.
 */
export function instanceOfPalAuthSubmissionMetadataErrorDetails(value: object): value is PalAuthSubmissionMetadataErrorDetails {
    return true;
}

export function PalAuthSubmissionMetadataErrorDetailsFromJSON(json: any): PalAuthSubmissionMetadataErrorDetails {
    return PalAuthSubmissionMetadataErrorDetailsFromJSONTyped(json, false);
}

export function PalAuthSubmissionMetadataErrorDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthSubmissionMetadataErrorDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'diagnosis_not_found': json['diagnosis_not_found'] == null ? undefined : json['diagnosis_not_found'],
        'invalid_servicing_provider_name': json['invalid_servicing_provider_name'] == null ? undefined : json['invalid_servicing_provider_name'],
        'platform_message': json['platform_message'] == null ? undefined : json['platform_message'],
        'payer_not_found': json['payer_not_found'] == null ? undefined : PalAuthSubmissionMetadataErrorDetailsPayerNotFoundFromJSON(json['payer_not_found']),
    };
}

export function PalAuthSubmissionMetadataErrorDetailsToJSON(json: any): PalAuthSubmissionMetadataErrorDetails {
    return PalAuthSubmissionMetadataErrorDetailsToJSONTyped(json, false);
}

export function PalAuthSubmissionMetadataErrorDetailsToJSONTyped(value?: PalAuthSubmissionMetadataErrorDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'diagnosis_not_found': value['diagnosis_not_found'],
        'invalid_servicing_provider_name': value['invalid_servicing_provider_name'],
        'platform_message': value['platform_message'],
        'payer_not_found': PalAuthSubmissionMetadataErrorDetailsPayerNotFoundToJSON(value['payer_not_found']),
    };
}

